export const handleResponse = async (response: Response) => {
  const data = await response.json()
  if (response.ok) {
    return data
  } else {
    // Backend'den gelen hata formatını koruyarak error object oluştur
    const error = new Error(data.message || 'Something went wrong')
    // Backend error bilgilerini error object'ine ekle
    Object.assign(error, {
      message: data.message,
      error: data.error,
      statusCode: data.statusCode || response.status
    })
    throw error
  }
}